// Catering Invoice Refund Related Enums

// catering_invoice_refund refundStatus Type Enum
export enum CateringInvoiceRefundStatus {
  INITIATED = 'refund-initiated',
  REFUNDED = 'refunded',
  FAILED = 'failed',
}
